import Image from 'next/image';
import { styled } from 'styled-components';
export const ProfileImg = styled(Image).withConfig({
  displayName: "ProfileImagestyle__ProfileImg",
  componentId: "sc-1hrntu8-0"
})(["", ""], {
  "aspectRatio": "1 / 1",
  "height": "100%",
  "width": "100%",
  "borderRadius": "9999px"
});